import { alertService, createStorePersist, RequestStatus } from "common-frontend-components";
import { getStorageCall } from "@yehonadav/safestorage";
import { useEffect } from "react";
import { callGetProductIconsAsync } from "../../apis/productIcons";
const persistOptions = {
    name: `ramibarilan/productIcons/store`,
    whitelist: ["photoList"],
    getStorage: getStorageCall,
};
const { useStore, fetchStore, set, get } = createStorePersist({
    persistOptions,
    persistAfterClearingStorage: false,
    getDefaultValues: () => ({
        photos: {},
        photoList: [],
        imageFullViewUrl: undefined,
        requestStatus: RequestStatus.pending,
    })
});
const getIcons = () => get().photoList;
const setIconsRaw = (photoList) => {
    const photos = {};
    photoList.forEach(i => {
        if (photos[i.productId] !== undefined)
            photos[i.productId].push(i);
        else
            photos[i.productId] = [i];
    });
    set({ photos, photoList: Object.values(photos) });
};
const setIcons = (photoList) => {
    const photos = {};
    photoList.forEach(i => { photos[i[0].productId] = i; });
    set({ photos, photoList });
};
// set categories from storage
setIcons(getIcons().map(list => { list.forEach(i => { i.created = new Date(i.created); return i; }); return list; }));
const setImageFullViewUrl = (imageFullViewUrl) => set({ imageFullViewUrl: imageFullViewUrl || undefined });
export const productIconsStore = {
    getIconsById: (productId) => get().photos[productId],
    getIcons,
    setIcons,
    setIconsRaw,
    useIcons: () => useStore(fetchStore.photoList),
    useIconsByProductId: (productId) => useStore(s => s.photos[productId]),
    getImageFullViewUrl: () => get().imageFullViewUrl,
    setImageFullViewUrl,
    useImageFullViewUrl: () => useStore(s => s.imageFullViewUrl),
    openImageFullViewUrl: (imageFullViewUrl) => setImageFullViewUrl(imageFullViewUrl),
    closeImageFullViewUrl: () => setImageFullViewUrl(undefined),
    getRequestStatus: () => get().requestStatus,
    // tslint:disable-next-line:no-shadowed-variable
    setRequestStatus: (requestStatus) => { console.log({ requestStatus }); const s = get(); s.requestStatus = requestStatus; set({ requestStatus }); },
    useRequestStatus: () => useStore(fetchStore.requestStatus),
    useLoad: () => {
        const status = productIconsStore.useRequestStatus();
        const data = productIconsStore.useIcons();
        useEffect(() => {
            if (get().requestStatus !== RequestStatus.pending)
                return;
            productIconsStore.setRequestStatus(RequestStatus.loading);
            callGetProductIconsAsync()
                .then((items) => {
                productIconsStore.setIconsRaw(items);
                productIconsStore.setRequestStatus(RequestStatus.loaded);
            })
                .catch((e) => {
                alertService.error(e);
                productIconsStore.setRequestStatus(RequestStatus.failed);
            });
        }, [status]);
        return { status, data };
    },
};
//# sourceMappingURL=productIconsStore.js.map